import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ListColumn } from '../list/list-column.model';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'app-list-search-button',
    templateUrl: './list-search-button.component.html',
    styleUrls: ['./list-search-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ListSearchButtonComponent implements OnInit  {

  @Input() name: string = '';
  @Input() columns: ListColumn[] = [];
  @Input() addBut: boolean = false;
  @Input() searchBut: boolean = false;
  @Input() addDownload: boolean = false;
  @Input() button_name: string = '';
  @Input() hideFilter: boolean = false;
  @Input() dataInTable: boolean = false;

  @ViewChild('filter') filter: ElementRef | undefined;
  @Output() filterChange = new EventEmitter<any>();
  @Output() reportDownload = new EventEmitter<any>();

  @Input() hideHeader: boolean = false;
  @Input() filterArray: any = [{id: 0, name: ''}];
  @Input() hasFilter: boolean = false;
  form?: UntypedFormGroup;
  hasDates: boolean = false;

  @Output() filterComboChange = new EventEmitter<number>();
  today = new Date(); 

  constructor(private readonly fb: UntypedFormBuilder, ) {

  }
  ngOnInit(): void {
    this.form = this.fb.group({
      search: ['0', []],
      startDate: ['', []],
      endDate: ['', []],
    });

    this.form.get("search")?.valueChanges.subscribe(x => {
      if (x != -1) {
        this.hasDates = false;
      } else {
        this.hasDates = true;
      }
      this.filterComboChange.emit(x);
   })

  }


  toggleColumnVisibility(column: any, event: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }

  sendSearchButton(){
    if (!this.hasDates) {
      this.filterChange.emit({type: 1, value: this.filter?.nativeElement.value});
    } else {
    let momentStringStart = '';
    let momentStringEnd = '';
    if (this.form?.get('startDate')?.value) {
      let momentObj = moment(this.form?.get('startDate')?.value);
      momentStringStart = momentObj.format('YYYY-MM-DD')
    }
    if (this.form?.get('endDate')?.value) {
      let momentObj = moment(this.form?.get('endDate')?.value);
      momentStringEnd = momentObj.format('YYYY-MM-DD')
    }


      this.filterChange.emit({type: 2, values: [momentStringStart, momentStringEnd]});
    }

  }

  sendReporthButton(){
    if (!this.hasDates) {
      this.reportDownload.emit({type: 1, value: this.filter?.nativeElement.value});
    } else {
      let momentStringStart = '';
      let momentStringEnd = '';
      if (this.form?.get('startDate')?.value) {
        let momentObj = moment(this.form?.get('startDate')?.value);
        momentStringStart = momentObj.format('YYYY-MM-DD')
      }
      if (this.form?.get('endDate')?.value) {
        let momentObj = moment(this.form?.get('endDate')?.value);
        momentStringEnd = momentObj.format('YYYY-MM-DD')
      }
      this.reportDownload.emit({type: 2, values: [momentStringStart, momentStringEnd]});
    }

  }


}
